import { React, useRef,useEffect,useState } from "react";

const { tableau } = window;
function Landing() {
    const ref = useRef(null)
    // const url = 'https://public.tableau.com/views/LearnEmbeddedAnalytics/SalesOverviewDashboard'
    const url = 'https://prod-apnortheast-a.online.tableau.com/trusted/eyJhbGciOiJIUzI1NiIsImlzcyI6ImUzNWI4MjE4LTRmN2EtNGMzOC1hNWUwLTQwZWZiOWUwYzcxYyIsImtpZCI6IjU1YTk3MTA4LWRhY2MtNGUyNi1hMmU3LTVmODFhMjM3NDVhMyIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJlMzViODIxOC00ZjdhLTRjMzgtYTVlMC00MGVmYjllMGM3MWMiLCJleHAiOjE3MjU1Mjk0MTQsImp0aSI6ImYzMGY2NzcxLThkZjMtNDY0NS1iN2E4LWNjZDUwZDJiNDE5MyIsImF1ZCI6InRhYmxlYXUiLCJzdWIiOiJzcmVlbml2YXN1bHUudEBzd2l0Y2htb2JpbGl0eWV2LmNvbSIsInNjcCI6WyJ0YWJsZWF1OnZpZXdzOmVtYmVkIiwidGFibGVhdTptZXRyaWNzOmVtYmVkIl0sImh0dHBzOi8vdGFibGVhdS5jb20vb2RhIjoidHJ1ZSIsImh0dHBzOi8vdGFibGVhdS5jb20vZ3JvdXBzIjpbIkNvbnRyYWN0b3JzIiwiVGVhbSBDIiwiR3JvdXAxIiwiR3JvdXAyIl0sIlJlZ2lvbiI6IkVhc3QifQ.1Ro6547hPNjRCN1pnjfl8ZoNOlwsjfvmb3DKEl4Lq-E/t/site/analyticspd/views/Telematics/Home'
   
    const initviz=()=>{
        new tableau.Viz(ref.current,url,{
            width:"100%",
            height:'100vh'
        })
    }
    useEffect(initviz,[])
    return (
        <div ref={ref}/>
            
);
}


export default Landing;